import { useState } from "react";
import TagsEditModal from "./TagsEditModal";
import { useParticipantTags } from "./useParticipantTags";
import TagsQuickViewPanel from "./TagsQuickViewPanel";

const TagsQuickView = ({ participantId }: { participantId: number }) => {
	const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

	const participantTags = useParticipantTags({ patientId: participantId });

	return (
		<>
			<TagsQuickViewPanel
				isLoading={participantTags.isLoading}
				isError={participantTags.isError}
				tags={participantTags.data}
				onClickAction={() => setIsModalOpen(true)}
			/>

			{isModalOpen && (
				<TagsEditModal
					participantId={participantId}
					closeModal={() => {
						setIsModalOpen(false);
						participantTags.invalidate();
					}}
					isVisible={isModalOpen}
				/>
			)}
		</>
	);
};

export default TagsQuickView;
